import { createStore, combineReducers } from 'redux';
import { toastsReducer, ToastsStore } from 'redux/toasts';
import { loadingReducer, LoadingStore } from './loading';
import { maintenanceReducer, MaintenanceStore } from './maintenance';
import { actionTypes, AuthStore, authReducer } from './auth';

export interface Store {
  auth: AuthStore;
  toasts: ToastsStore;
  loading: LoadingStore;
  maintenance: MaintenanceStore;
}

const combineReducer = combineReducers({
  auth: authReducer,
  toasts: toastsReducer,
  loading: loadingReducer,
  maintenance: maintenanceReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === actionTypes.LOGOUT) {
    state = undefined;
  }
  return combineReducer(state, action);
};

export const store = createStore(
  rootReducer,
  (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__()
);
